import { Launch16, Launch24, OverflowMenuVertical24 } from '@carbon/icons-react'
import { ISimplifiedVisualMaterial } from '@libs/api'
import { IconButton } from '@libs/components'
import { useLocalization } from '@libs/localization'
import { Button, Dropdown, Menu } from 'antd'
import React from 'react'

import Styled from './Styled'

export const VideoLinksDropdown = ({
	links,
	size = 'small',
}: {
	links: ISimplifiedVisualMaterial['links']
	size?: 'small' | 'middle'
}) => {
	const { t } = useLocalization()

	const navigateToLink = (url: string) => {
		window.open(url, '_blank')
	}

	return (
		<Dropdown
			placement={'bottomRight'}
			overlay={
				<Menu>
					{links.map(({ name, url }) => (
						<Styled.LinkItem key={name} onClick={() => navigateToLink(url)}>
							{t(`materials.card.videoLinks.names.${name}`)}
							{size === 'small' ? <Launch16 /> : <Launch24 />}
						</Styled.LinkItem>
					))}
				</Menu>
			}
		>
			{size === 'small' ? (
				<IconButton size="small" title={t('materials.card.videoLinks.title')}>
					<OverflowMenuVertical24 />
				</IconButton>
			) : (
				<Button size="small">{t('materials.card.videoLinks.title')}</Button>
			)}
		</Dropdown>
	)
}
